import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import CloseIcon from '../themes/svg/closeIcon';

class NameEntryModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: props.defaultName,
      validInput: true,
      errors: [],
    };
  }

  componentWillMount() {
    Modal.setAppElement('#estimateBuilderRoot');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.modalIsOpen) {
      this.setState({ name: nextProps.defaultName }, this.validate);
    }
  }

  onCloseClick = (e) => {
    this.closeModal();
    e.preventDefault();
  };

  onChange = (e) => {
    e.preventDefault();
    this.setState({ name: e.target.value }, this.validate);
  };

  onVerbClick = () => {
    this.props.action(this.state.name.trim());
    this.closeModal();
  };

  closeModal = () => {
    this.setState({ validInput: true, name: this.props.defaultName }, this.props.closeModal);
  };

  validate = () => {
    const result = this.props.validate(this.state.name);
    this.setState({ ...result });
  };

  render() {
    const inputClassName = this.state.validInput ? 'full-width' : 'full-width warn-input';
    return (
      <Modal
        isOpen={this.props.modalIsOpen}
        onRequestClose={this.closeModal}
        className="estimatebuilder-modal"
        overlayClassName="estimatebuilder-modal-overlay"
        style={{
          content: {
            width: 450,
          },
        }}
      >
        <div className="nameEntryModal">
          <h2>{this.props.title}</h2>

          <div className="modal-close" onClick={this.onCloseClick} tabIndex="-1" role="button">
            <CloseIcon />
          </div>
          <div className="modal-body">
            {this.props.instructions.length > 0 && <p>{this.props.instructions}</p>}
            <input
              id="entered-name"
              className={inputClassName}
              value={this.state.name}
              onChange={this.onChange}
            />
            {!this.state.validInput &&
              this.state.errors.map((givenError, idx) => <span id={`error-${idx}`} className="warn">{givenError}</span>)}
            <button
              id="actionButton"
              className="btn btn-primary"
              disabled={!this.state.validInput}
              onClick={this.onVerbClick}
            >
              {this.props.verb}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

NameEntryModal.propTypes = {
  action: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  instructions: PropTypes.string,
  verb: PropTypes.string.isRequired,
  defaultName: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
};

NameEntryModal.defaultProps = {
  instructions: '',
};

export default NameEntryModal;
